"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TharsisPrototypeCity = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const Resources_1 = require("../../../Resources");
const CardRenderer_1 = require("../../render/CardRenderer");
const Tags_1 = require("../../Tags");
const Units_1 = require("../../../Units");
const DeferredAction_1 = require("../../../deferredActions/DeferredAction");
const SelectSpace_1 = require("../../../inputs/SelectSpace");
const TileType_1 = require("../../../TileType");
const SpaceType_1 = require("../../../SpaceType");
const BoardType_1 = require("../../../boards/BoardType");
class TharsisPrototypeCity extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.THARSIS_PROTOTYPE_CITY,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.BUILDING, Tags_1.Tags.CITY],
            productionBox: Units_1.Units.of({ megacredits: 1, energy: 1 }),
            metadata: {
                cardNumber: 'Y23',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.city().asterix();
                    b.production((pb) => pb.megacredits(1).energy(1));
                }),
                description: 'Place a city tile. Do not collect any placement bonuses. Increase your M€ and energy production 1 step each.',
            },
        });
    }
    play(player) {
        const spaces = player.game.board.getAvailableSpacesForCity(player);
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            return new SelectSpace_1.SelectSpace('Select space for prototype city tile', spaces, TileType_1.TileType.CITY, (space) => {
                player.game.addTile(player, SpaceType_1.SpaceType.LAND, space, { tileType: TileType_1.TileType.CITY }, false);
                if (player.isCorporation(CardName_1.CardName.CURIOSITY_II)) {
                    const curiosityII = player.corporationCards.find((c) => c.name === CardName_1.CardName.CURIOSITY_II);
                    curiosityII.onTilePlaced(player, player, space, BoardType_1.BoardType.MARS);
                }
                return undefined;
            });
        }));
        player.addProduction(Resources_1.Resources.MEGACREDITS);
        player.addProduction(Resources_1.Resources.ENERGY);
        return undefined;
    }
}
exports.TharsisPrototypeCity = TharsisPrototypeCity;
//# sourceMappingURL=TharsisPrototypeCity.js.map